import { MINCOL } from "../../../constants/const"
import JaNeinFilter from "../JaNeinFilter"
import DropdownFilter from "../SD_einsehen/DropdownFilter"

export const notizenHeader = [
    {accessor: 'entity',
    Header: 'in Tabelle',
    width: MINCOL,
    Filter: DropdownFilter
    },
    {accessor: 'note',
    Header: 'Beschreibung',
    width: '50em'
    },
    {id: 'erledigt',
    Header: 'ist registriert',
    accessor: d => d.recognized ? "ja" : "nein",
    width: MINCOL,
    Filter: JaNeinFilter
    }
];



export const hiddenColumns = ['id']